import * as React from 'react';
import { FMIconButton, FMIconType, FMMenu } from 'atoms';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

interface Props {
    iconType: FMIconType;
    menuId: string;
    menuData: MenuItemData[];
    tooltip?: string;
}

interface MenuItemData {
    text: string;
    action: () => void;
}

interface State {
    anchorEl: any;
}

export default class FMIconMenuButton extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = {
            anchorEl: null,
        };
    }

    private openMenu = (event: React.MouseEvent) => {
        this.setState({
            anchorEl: event.currentTarget,
        });
    }

    private closeMenu = () => {
        this.setState({
            anchorEl: null,
        });
    }

    private createMenuItemClick = (action: () => void) => () => {
        this.closeMenu();
        action();
    }

    public render() {
        return (
            <React.Fragment>
                <FMIconButton
                    color="secondary"
                    type={this.props.iconType}
                    onClick={this.openMenu}
                    aria-owns={this.state.anchorEl ? this.props.menuId : undefined }
                    aria-haspopup="true"
                    tooltip={this.props.tooltip}
                />
                <FMMenu
                    id={this.props.menuId}
                    anchorEl={this.state.anchorEl}
                    open={this.state.anchorEl !== null}
                    onClose={this.closeMenu}
                >
                {
                    this.props.menuData.map(item =>
                        <MenuItem
                            key={item.text}
                            onClick={this.createMenuItemClick(item.action)}
                            disableRipple={true}
                        >
                            <Typography>{item.text}</Typography>
                        </MenuItem>
                    )
                }
                </FMMenu>
            </React.Fragment>
        );
    }

};
